export const isProduct = window.location.hostname === 'store.relxtech.com';
export const isProdOrYufa =
  window.location.hostname === 'store.relxtech.com' ||
  window.location.hostname === 'store-stage.relxtech.com';

export const ID_JIDU_YOUXUAN = isProdOrYufa ? 19 : 48;
export const SILVER_THEME_ACT = '国标货足';

export const MAP_API_HOSTS: { [p: string]: string } = {
  'store.relxtech.com': 'https://storeapi.relxtech.com',
  'store-stage.relxtech.com': 'https://storeapi-stage.relxtech.com',
  'teststore.relxtech.com': 'https://teststoreapi.relxtech.com',
};

export const MAP_APP_HOST: { [p: string]: string } = {
  'store.relxtech.com': 'https://app.relxtech.com',
  'store-stage.relxtech.com': 'https://app-stage.relxtech.com',
  'teststore.relxtech.com': 'https://apptest.relxtech.com',
};

export const MAP_CRM_HOST: { [p: string]: string } = {
  'store.relxtech.com': 'https://crm.relxtech.com',
  'store-stage.relxtech.com': 'https://crm-stage.relxtech.com',
  'teststore.relxtech.com': 'https://crmtest.relxtech.com',
};

export const API_HOST: string =
  MAP_API_HOSTS[window.location.hostname] ||
  'https://teststoreapi.relxtech.com';

export const APP_HOST: string =
  MAP_APP_HOST[window.location.hostname] || 'https://apptest.relxtech.com';

export const CRM_HOST: string =
  MAP_CRM_HOST[window.location.hostname] || 'https://crmtest.relxtech.com';

export const CORP_LINKS = {
  products:
    'https://app.relxtech.com/app/product/series?utm_source=mendian_productknowledge&utm_campaign=product_knowledge',
};

// https://app.relxtech.com/app/product/all?series_id=${}
export const PRODUCTS = [
  {
    pid: 54,
    img:
      'https://oss-static.relxtech.com/relxapi/app/filedata/2021-09-14/5193d0a2-7361-443b-90bd-eebce872fa5f%E4%B8%80%E6%BA%AA%E4%BA%91.jpg',
    id: 10,
    name: '一溪云',
  },
  {
    pid: 59,
    img:
      'https://oss-static.relxtech.com/relxapi/app/filedata/2021-10-22/b865c53f-4bd4-481a-ab41-937606323ff3%E7%94%BB%E6%9D%BF%E2%80%931%402x.jpg',
    id: 9,
    name: '星河',
  },
  { pid: 3, img: require('@/assets/images/2.0/p5.jpg'), id: 5, name: '无限' },
  { pid: 39, img: require('@/assets/images/2.0/p7.jpg'), id: 7, name: '幻影' },
  { pid: 6, img: require('@/assets/images/2.0/p1.jpg'), id: 1, name: '一代' },
  { pid: 4, img: require('@/assets/images/2.0/p3.jpg'), id: 3, name: '灵点' },
  { pid: 5, img: require('@/assets/images/2.0/p2.jpg'), id: 2, name: '阿尔法' },
  {
    pid: 45,
    img:
      'https://oss-static.relxtech.com/relxapi/app/filedata/2021-09-24/dcf9e29d-64ce-4be0-8af8-935b875f6726%E6%B8%90%E5%8F%98%E8%89%B2.jpg',
    id: 8,
    name: '轻风',
  },
  { pid: 1, img: require('@/assets/images/2.0/p4.jpg'), id: 4, name: '云白' },
  {
    pid: -1,
    img:
      'https://oss-static.relxtech.com/relxapi/app/filedata/2021-01-28/382d2c1b-8d20-44b9-b0c8-244a8a50599f%E5%88%97%E8%A1%A8%E5%B0%81%E9%9D%A2.jpg',
    id: 12,
    name: '幻彩',
  },
  { pid: 2, img: require('@/assets/images/2.0/p6.jpg'), id: 6, name: '小悦刻' },
  {
    pid: 0,
    img:
      'https://oss-static.relxtech.com/shopkeeper/file/2021-11-16/b638d931-bbe0-4ab0-9812-56528841c71azb.jpg',
    id: 11,
    name: '周边',
  },
];

export const PREM_STORE_IDS = [25498, 10933, 19381, 19382, 10892];

export const DEFAULT_TITLE = '查找你附近的门店';

export const APP_ROUTES = {
  // 用户主页
  userHome: 'relx://page/user/userDynamicPage',
  // 口味帖子详情
  tastePost: 'relx://page/social/dynamicDetailPage',
  // 口味帖子列表
  tasteList: 'relx://page/social/tasteListPage',
  // 烟杆帖子列表
  rodPostList: 'relx://page/social/productListPage',
  // 标签帖子列表
  tagList: 'relx://page/social/tagDynamicPage',
  // 社区
  social: 'relx://page/home/homePage?params={"index":"PAGE_SOCIAL"}',
  // 打卡
  daka: 'relx://page/card/pushCardPage',
  // 免费雾化弹
  freePod:
    'relx://page/home/webPage?params={"url":"https://app.relxtech.com/app/appraise?t=2"}',
  // 更多福利
  moreWeel:
    'relx://page/home/webPage?params={"url":"https://app.relxtech.com/mcrm/invite?c=25"}',
  // 年龄认证
  certify: 'relx://page/ageVerb/idCardCertifyPage',
  // 神秘雾化弹评测
  amazingPodList:
    'relx://page/social/tagDynamicPage?params={"id":"170","name":"神秘雾化弹测评"}',
  // 福利中心
  integralPage: 'relx://page/integral/integralPage',
  // 话题广场
  topicSquare: 'relx://page/social/topicSquare',
  // 登陆
  login: 'relx://page/user/loginHomePage',
};

export const SERVICE_CALL = '4000-117-100';

export const STORE_SUB_TYPE: { [prop: number]: string } = {
  101: '专卖店',
  102: '直营店',
  201: '店中店',
  202: 'NKA',
  203: 'RKA',
  204: 'B2B',
  205: 'TT',
  206: '3C',
};

export const CALL_CENTER_HREF =
  'https://app.relxtech.com/app/callcenter?web_plugin_id=29856';

export const APPID = 'relx-map';

export const APP_NAME = '附近门店';

// export const DEFAULT_GPS = {
//   // 上海的地址测试用的
//   lng: window.location.hostname === 'store.relxtech.com' ? 116.439945 : 121.48,
//   lat: window.location.hostname === 'store.relxtech.com' ? 39.927462 : 31.22,
// };

export const DEFAULT_GPS = {
  lng: 116.439945,
  lat: 39.927462,
};

export const DEFAULT_SHARE = {
  title: '查找RELX门店',
  desc: '立即前往附近的门店体验，感受RELX给你带来的愉悦体验',
  imgUrl:
    'https://oss-static.relxtech.com/store/images/rBB7k11CUWCACQjNAAAUARsV5pc175.png',
  link: window.location.origin,
};
